const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAD24D"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EDB937"
    },
    cx: 256,
    cy: 421.646,
    rx: 182.284,
    ry: 14.371
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M65.982,67.223h380.037c12.486,0,22.702,10.216,22.702,22.702v234.107H43.282V89.924 c0-12.486,10.216-22.702,22.702-22.702H65.982z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M58.694,308.617h394.609V89.924c0-3.979-3.309-7.288-7.285-7.288H65.982 c-3.977,0-7.285,3.309-7.285,7.288v218.693H58.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.718,324.031v24.827c0,12.488-11.26,22.702-25.024,22.702H68.307 c-13.764,0-25.024-10.214-25.024-22.702v-24.827H468.72H468.718z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 256,
    cy: 346.803,
    r: 7.816
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C4"
    },
    d: "M305.066,407.273l36.095,11.566H170.836l29.123-11.566v-35.713h105.105v35.713H305.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M199.961,407.273h105.106l36.095,11.566v4.98h-85.16h-85.164v-4.98L199.961,407.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191"
    },
    d: "M199.961,371.559h105.106v35.713L199.961,371.559z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.849,
    y: 97.5,
    style: {
      fill: "#20D0C2"
    },
    width: 40.742,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.303,
    y: 97.5,
    style: {
      fill: "#FF5B62"
    },
    width: 72.269,
    height: 7.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.055,
    y: 97.5,
    style: {
      fill: "#FAD24D"
    },
    width: 61.53,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.648,
    y: 126.363,
    style: {
      fill: "#FAD24D"
    },
    width: 21.616,
    height: 7.016
  })), /*#__PURE__*/React.createElement("rect", {
    x: 142.761,
    y: 126.363,
    style: {
      fill: "#FF5B62"
    },
    width: 38.345,
    height: 7.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.953,
    y: 126.363,
    style: {
      fill: "#20D0C2"
    },
    width: 32.642,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.592,
    y: 138.689,
    style: {
      fill: "#20D0C2"
    },
    width: 37.976,
    height: 7.016
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.95,
    y: 138.689,
    style: {
      fill: "#FAD24D"
    },
    width: 67.348,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.133,
    y: 153.42,
    style: {
      fill: "#FF5B62"
    },
    width: 37.976,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.49,
    y: 153.42,
    style: {
      fill: "#20D0C2"
    },
    width: 67.348,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.359,
    y: 167.503,
    style: {
      fill: "#FAD24D"
    },
    width: 37.976,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.355,
    y: 167.503,
    style: {
      fill: "#20D0C2"
    },
    width: 27.177,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.93,
    y: 167.503,
    style: {
      fill: "#FF5B62"
    },
    width: 76.311,
    height: 7.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.83,
    y: 167.503,
    style: {
      fill: "#20D0C2"
    },
    width: 27.177,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.245,
    y: 182.234,
    style: {
      fill: "#20D0C2"
    },
    width: 101.622,
    height: 7.016
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.298,
    y: 182.234,
    style: {
      fill: "#FAD24D"
    },
    width: 27.177,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.347,
    y: 182.234,
    style: {
      fill: "#FF5B62"
    },
    width: 37.976,
    height: 7.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.375,
    y: 111.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.807,
    height: 8.416
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.193,
    y: 138.689,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.807,
    height: 8.416
  })), /*#__PURE__*/React.createElement("rect", {
    x: 75.849,
    y: 202.994,
    style: {
      fill: "#20D0C2"
    },
    width: 40.742,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.303,
    y: 202.994,
    style: {
      fill: "#FF5B62"
    },
    width: 72.269,
    height: 7.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.055,
    y: 202.994,
    style: {
      fill: "#FAD24D"
    },
    width: 61.53,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.648,
    y: 231.847,
    style: {
      fill: "#FAD24D"
    },
    width: 21.616,
    height: 7.016
  })), /*#__PURE__*/React.createElement("rect", {
    x: 142.761,
    y: 231.847,
    style: {
      fill: "#FF5B62"
    },
    width: 38.345,
    height: 7.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.953,
    y: 231.847,
    style: {
      fill: "#20D0C2"
    },
    width: 32.642,
    height: 7.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.592,
    y: 244.183,
    style: {
      fill: "#20D0C2"
    },
    width: 37.976,
    height: 7.016
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.95,
    y: 244.183,
    style: {
      fill: "#FAD24D"
    },
    width: 67.348,
    height: 7.016
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.375,
    y: 216.577,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.807,
    height: 8.416
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.193,
    y: 244.183,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.807,
    height: 8.416
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.223,
    y: 97.5,
    style: {
      fill: "#DCE3DB"
    },
    width: 147.352,
    height: 33.984
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M290.221,136.298h70.178v44.852h-70.178V136.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M367.398,136.298h70.178v44.852h-70.178V136.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M290.423,187.581h146.953v2.172H290.423V187.581z M290.423,208.115h96.534v2.172h-96.534V208.115z  M290.423,201.269h146.953v2.172H290.423V201.269z M290.423,194.426h146.953v2.172H290.423V194.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M290.048,215.622h43.793v43.42h-43.793V215.622z M393.961,215.622h43.795v43.42h-43.795V215.622z  M342.005,215.622h43.793v43.42h-43.793V215.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M290.423,265.088h146.953v2.172H290.423V265.088z M290.423,285.622h96.534v2.172h-96.534V285.622z  M290.423,278.777h146.953v2.172H290.423V278.777z M290.423,271.934h146.953v2.172H290.423V271.934z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/web_dev.1aff7a0cece31d5180794a9d9a8420d5.svg";
export { ForwardRef as ReactComponent };